import React from "react";
import M from "moment/moment";

const initialPersonalData = {
    name: null,
    nik: null,
    hpNumber1: null,
    hpNumber2: null,
    email: null,
    address: null,
    kkNumber: null,
    npwp: null,
    province: null,
    kabkot: null,
    kecamatan: null,
    kelurahan: null,
    zipCode: null,
    gender: null,
    job1: null,
    job2: null,
    religion: null,
    memberId: null,
    memberLevel: null,
    loyaltyLevel: null,
    facebook: null,
    instagram: null,
    linkedin: null,
    x: null,
    tiktok: null,
    hobby: null,
    interest: null,
}

const initialDataPembeli = {
    isCompany: false,
    ...initialPersonalData
}

const initialDataPemilik = {
    isBuyer: false,
    ...initialPersonalData
}

const initialDataReferal = {
    isMakelarProfessional: false,
    ...initialPersonalData
}

const initialDataDelivery = {
    alamatType: null,
    alamat: null,
    province: null,
    kabKot: null,
    kecamatan: null,
    kelurahan: null,
    kodePos: null,
    patokan: null,
    catatan: null,
}

const initialDataTransaction = {
    headerTransaction: {
        tipeHargaUnit: "ON_THE_ROAD",
        hargaOtrOff: 0,
        hargaDiberikan: 0,
        nomorBuku: null,
        idSalesProgramDgi: null,
        salesPersonId: null,
        levelMarketing: null
    },
    detailTransaction: {
        pembayaranUnit: {
            tipePayment: null,
            salesProgramId: null,
            leasingId: null,
            leasing: null,
            dpPo: 0,
            subsidiUmLeasing: 0,
            angsuran: 0,
            tenor: 0,
            noPo: null,
            discountMax: 0,
            discountMin: 0,
            discountDiberikan: 0,
            mk: 0,
            overDiscount: 0,
            tk: 0,
            biayaLainlain: 0,
            scpAhm: 0,
            scpMd: 0,
            scpDealer: 0,
            subsidiLain: 0,
            tentative: false
        },
        dataTransaksiTambahan: {
            promoIdAhm: null,
            ppn: null
        },
        pembayaranKonsumen: {
            nilaiHarusSetor: 0,
            dibayarTunai: 0,
            dibayarTransfer: 0,
            bank: null,
            dibayarRumah: 0,
            cashTempo: 0,
            tanggalDeadlineTempo: null,
            totalAmount: 0
        }
    }
}

const initialDataUnit = {
    kodeVariant: null,
    namaVariant: null,
    tipe: null,
    series: null,
    idWarna: null,
    namaWarnaKomersil: null
}

const initialDataPhoto = {
    kartuKeluargaBase64: null,
    ktpBase64: null
}

const initialDataNote = {
    note: null
}

const personalData = {
    name: {value: null, mandatory: true},
    nik: {value: null},
    hpNumber1: {value: null, mandatory: true},
    hpNumber2: {value: null},
    email: {value: null, mandatory: true},
    address: {value: null, mandatory: true},
    kkNumber: {value: null},
    npwp: {value: null},
    provinceId: {value: null, mandatory: true},
    kabkotId: {value: null, mandatory: true},
    kecamatanId: {value: null, mandatory: true},
    kelurahanId: {value: null, mandatory: true},
    zipCode: {value: null},
    gender: {value: null, mandatory: true},
    job1: {value: null, mandatory: true},
    job2: {value: null},
    religion: {value: null, mandatory: true},
    memberId: {value: null},
    memberLevel: {value: null},
    loyaltyLevel: {value: null},
    facebook: {value: null},
    instagram: {value: null},
    linkedIn: {value: null},
    x: {value: null},
    tiktok: {value: null},
    hobby: {value: null},
    interest: {value: null},
}

export const formGroup = {
    id: {value: null},
    orderDate: {value: null},
    kodeCabang: {value: null, mandatory: true},
    indentNo: {value: null},
    prospectNo: {value: null},
    jenisProspect: {value: null},
    dataPembeli: {
        isCompany: {value: null},
        ...personalData
    },
    dataPemilik: {
        isBuyer: {value: null},
        ...personalData
    },
    dataDelivery: {
        alamatType: {value: null},
        alamat: {value: null, mandatory: true},
        kodeProvinsi: {value: null, mandatory: true},
        kodeKabkot: {value: null, mandatory: true},
        kodeKecamatan: {value: null, mandatory: true},
        kodeKelurahan: {value: null, mandatory: true},
        kodePos: {value: null},
        patokan: {value: null},
        catatan: {value: null},
    },
    dataReferral: {
        isMakelarProfessional: {value: null},
        ...personalData
    },
    dataPhoto: {
        ktpBase64: {value: null, mandatory: true},
        kartuKeluargaBase64: {value: null},
    },
    dataKeterangan: {
        keterangan: {value: null},
    },
    dataUnit: {
        idWarna: {value: null, mandatory: true},
        kodeVariant: {value: null, mandatory: true},
        nomorMesin: {value: null, mandatory: true},
        nomorRangka: {value: null, mandatory: true},
    },
    dataPackage: {
        selectedPackage: {value: null, mandatory: true},
    },
    dataTransaction: {
        hargaDiberikan: {value: 0, mandatory: true},
        nomorBuku: {value: null, mandatory: true},
        salesPersonId: {value: null, mandatory: true},
    },
    pembayaranUnit: {
        tipePayment: {value: null, mandatory: true},
        leasingId: {value: null},
        salesProgramId: {value: null, mandatory: true},
        dpPo: {value: 0},
        angsuran: {value: 0},
        noPo: {value: null},
        discountDiberikan: {value: 0, mandatory: true},
        scpAhm: {value: 0, mandatory: true},
        scpMd: {value: 0, mandatory: true},
        scpDealer: {value: 0, mandatory: true},
        subsidiLain: {value: 0, mandatory: true},
        tentative: {value: false},
        tenor: {value: 0},
        mk: {value: 0, mandatory: true},
        tk: {value: 0, mandatory: true},
        biayaLainlain: {value: 0, mandatory: true},
        subsidiUmLeasing: {value: 0}
    },
    pembayaranKonsumen: {
        nilaiHarusSetor: {value: 0},
        dibayarTunai: {value: 0, mandatory: true},
        dibayarTransfer: {value: 0, mandatory: true},
        dibayarRumah: {value: 0, mandatory: true},
    },
};

const tableColumnDataCustomer = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "name",
        label: "Nama",
        options: {
            sort: false,
        },
    },
    {
        name: "hpNumber1",
        label: "Telepon",
        options: {
            sort: false,
        },
    },
    {
        name: "nik",
        label: "NIK",
        options: {
            sort: false,
        },
    },
    {
        name: "tanggalLahir",
        label: "Tanggal Lahir",
        options: {
            sort: false,
        },
    },
    {
        name: "address",
        label: "Alamat",
        options: {
            sort: false,
        },
    },
    {
        name: "province",
        label: "Provinsi",
        options: {
            customBodyRender: (val) => <>{val.label}</>,
            sort: false,
        },
    },
    {
        name: "kecamatan",
        label: "Kecamatan",
        options: {
            customBodyRender: (val) => <>{val.label}</>,
            sort: false,
        },
    },
    {
        name: "kelurahan",
        label: "Kelurahan",
        options: {
            customBodyRender: (val) => <>{val?.label}</>,
            sort: false,
        },
    },
]

const tableColumnDataIndent = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "indentNo",
        label: "Nomor Indent",
        options: {
            sort: false,
        },
    },
    {
        name: "sellerName",
        label: "Penjual",
        options: {
            sort: false,
        },
    },
    {
        name: "name",
        label: "Nama",
        options: {
            sort: false,
        },
    },
    {
        name: "hpNumber1",
        label: "Telepon",
        options: {
            sort: false,
        },
    },
    {
        name: "address",
        label: "Alamat",
        options: {
            sort: false,
        },
    },
    {
        name: "provinceId",
        label: "Provinsi",
        options: {
            customBodyRender: (val) => <>{val.label || "-"}</>,
            sort: false,
        },
    },
    {
        name: "kecamatanId",
        label: "Kecamatan",
        options: {
            customBodyRender: (val) => <>{val.label || "-"}</>,
            sort: false,
        },
    },
    {
        name: "kelurahanId",
        label: "Kelurahan",
        options: {
            customBodyRender: (val) => <>{val.label || "-"}</>,
            sort: false,
        },
    },
]

const tableColumnDataProspect = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "prospectNo",
        label: "Nomor Prospek",
        options: {
            sort: false,
        },
    },
    {
        name: "pemilikProspek",
        label: "Pemilik Prospek",
        options: {
            sort: false,
        },
    },
    {
        name: "name",
        label: "Nama",
        options: {
            sort: false,
        },
    },
    {
        name: "hpNumber1",
        label: "Telepon",
        options: {
            sort: false,
        },
    },
    {
        name: "address",
        label: "Alamat",
        options: {
            sort: false,
        },
    },
    {
        name: "provinceId",
        label: "Provinsi",
        options: {
            customBodyRender: (val) => <>{val.label || "-"}</>,
            sort: false,
        },
    },
    {
        name: "kecamatanId",
        label: "Kecamatan",
        options: {
            customBodyRender: (val) => <>{val.label || "-"}</>,
            sort: false,
        },
    },
    {
        name: "kelurahanId",
        label: "Kelurahan",
        options: {
            customBodyRender: (val) => <>{val.label || "-"}</>,
            sort: false,
        },
    },
];

const jenisProspectOptions = [
    {label: "XS H21P", value: "XS H21P"},
    {label: "XS H21", value: "XS H21"},
    {label: "RO H1", value: "RO H1"},
    {label: "NEW", value: "NEW"},
];

const tableColumnDataNokaNosin = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
            sort: false,
        },
    },
    {
        name: "kodeVariant",
        label: "Kode Varian",
        options: {
            sort: false,
        },
    },
    {
        name: "namaVariant",
        label: "Nama Varian",
        options: {
            sort: false,
        },
    },
    {
        name: "kodeWarna",
        label: "Kode Warna",
        options: {
            sort: false,
        },
    },
    {
        name: "namaWarnaKomersil",
        label: "Nama Warna",
        options: {
            sort: false,
        },
    },
    {
        name: "nomorMesin",
        label: "No. Mesin",
        options: {
            sort: false,
        },
    },
    {
        name: "nomorRangka",
        label: "No. Rangka",
        options: {
            customBodyRender: (val) => <>{val}</>,
            sort: false,
        },
    },
    {
        name: "locator",
        label: "Locator",
        options: {
            customBodyRender: (val) => <>{val}</>,
            sort: false,
        },
    },
    {
        name: "usia",
        label: "Usia (Days)",
        options: {
            customBodyRender: (val) => <>{val}</>,
            sort: false,
        },
    },
]

const dummyData = {
    id: "FJ/CAB001/2025/03/98765",
    orderDate: M(new Date).format("DD-MM-YYYY"),
    kodeCabang: {label: "Nagamas", value: "Nagamas"},
    indentNo: "IDN/XV/01/2021",
    prospectNo: "PROS/XV/01/2021",
    jenisProspect: {label: "NEW", value: "NEW"},
    dataPembeli: {
        isCompany: true,
        name: "Angriawan Jhiro",
        nik: 323756439870012,
        hpNumber1: 62812345678910,
        hpNumber2: 62812345678910,
        email: "safei@gmail.com",
        address: "Jl Buntu Blok Buntu Nomor 0 Pondok Labu, Cilandak, Jakarta Selatan",
        kkNumber: 32761245786620017,
        npwp: "5387508388849221",
        provinceId: {label: "DKI Jakarta", value: "DKI JAKARTA"},
        kabkotId: {label: "Jakarta Selatan", value: "Jakarta Selatan"},
        kecamatanId: {label: "Cilandak", value: "Cilandak"},
        kelurahanId: {label: "Pondok Labu", value: "Pondok Labu"},
        zipCode: {label: "12450", value: "12450"},
        gender: {label: "Laki-Laki", value: "L"},
        job1: "Full Stack Developer",
        job2: "Content Writer",
        religion: "Islam",
        customerId: "4f6b",
        memberLevel: "Gold",
        loyaltyLevel: "Premium",
        facebook: "angriawanjhiro",
        instagram: "angriawanjhiro",
        linkedIn: "angriawanjhiro",
        x: "angriawanjhiro",
        tiktok: "angriawanjhiro",
        hobby: {label: "Bulu Tangkis", value: "Bulu Tangkis"},
        interest: {label: "Software Engineer", value: "Software Engineer"},
    }
}

const dummyDataNokaNosin = {
    kodeVariant: "V001",
    namaVariant: "XS H21",
    kodeWarna: "W001",
    idWarna: "09ab7f",
    namaWarnaKomersil: "Coklat",
    nomorMesin: "1234567890",
    nomorRangka: "1234567890",
    locator: "dealerABC",
    usia: "10"
}

export const config = {
    jenisProspectOptions,
    tableColumnDataCustomer,
    tableColumnDataIndent,
    tableColumnDataProspect,
    tableColumnDataNokaNosin,
    dummyDataNokaNosin,
    dummyData,
    initialDataPembeli,
    initialDataPemilik,
    initialDataReferal,
    initialDataDelivery,
    initialDataTransaction,
    initialDataUnit,
    initialDataPhoto,
    initialDataNote
}